var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMagnifyingGlass = function SvgMagnifyingGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "clear",
    fillRule: "evenodd",
    d: "M6.431 1.245a5.187 5.187 0 1 0 0 10.373 5.187 5.187 0 0 0 0-10.373M0 6.43a6.431 6.431 0 1 1 11.398 4.087L16 15.12l-.88.88-4.602-4.602A6.431 6.431 0 0 1 0 6.431",
    clipRule: "evenodd"
  })));
};
export default SvgMagnifyingGlass;